/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ApiConfig} from "../../api";
import {Injectable} from '@angular/core';
import * as moment from "moment";
import {AdnHttpService} from '../../../util/adn-http.service';
import {AdnHttpResponseSender, createAdnHttpResponseSender} from '../../../util/create-adn-http-resource';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';



@Injectable()
export class TrafficHistogramResource {
  private readonly uri = ApiConfig.obtain().getVersionedUri('traffichistogram');
  private readonly sendResponse: AdnHttpResponseSender;

  constructor(
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService
  ) {
    this.sendResponse = createAdnHttpResponseSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  }

  get(objectId: string,
      param: string,
      types: string[],
      filter: Record<string, string[]>,
      startDate: moment.Moment,
      endDate: moment.Moment) {
    types = types || [];
    filter = filter || {};
    const apiParams = {
      types: types,
      filter: filter,
      startDate: startDate ? startDate.toISOString() : null,
      endDate: endDate ? endDate.toISOString() : null
    };
    apiParams[param] = objectId;
    return this.sendResponse({method: 'POST', url: this.uri, body: apiParams});
  }
}
